var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 577,
    viewBox: "0 0 586 577",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1339_18474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 577
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 577,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1339_18474)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1339_18474)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 565.5,
    cy: 523.5,
    r: 382.5,
    fill: "#E7EDFD"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1339_18474)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 607,
    cy: 526.5,
    rx: 209,
    ry: 208.5,
    fill: "#7D97F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1339_18474",
    x: 0,
    y: -42,
    width: 1131,
    height: 1131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 91.5,
    result: "effect1_foregroundBlur_1339_18474"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1339_18474",
    x: 215,
    y: 135,
    width: 784,
    height: 783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 91.5,
    result: "effect1_foregroundBlur_1339_18474"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomGradient);
export default __webpack_public_path__ + "static/media/bottom_gradient.42a2a7d1bc83f3325a6bcde90835ae62.svg";
export { ForwardRef as ReactComponent };